// group name of every data row, filled by a11yTable() so both features agree on what a group is
const rowGroupNames = new WeakMap();

// markup indentation leaks into textContent, so collapse every whitespace run into one space
function normalizeText(string) {
  return string.replace(/\s+/g, ' ').trim();
}

// a heading row holds fewer cells than the table has columns
function isGroupRow(row, colCount) {
  return row.children.length < colCount;
}

// build a unique accessible name for a link: "Virtual Tour, Grand Ballroom"
function buildLinkLabel(link) {
  const label = normalizeText(link.textContent);
  const cell = link.closest('td');

  if (!cell) return label;

  const row = cell.closest('tr');

  if (!row) return label;

  // icon-only links have no text, so the label starts with the context instead
  const context = label ? [label] : [];

  // row name — own first cell of the row, so a nested table cannot supply it
  const firstCell = row.querySelector(':scope > td:first-child');
  if (firstCell && firstCell !== cell) {
    const rowName = normalizeText(firstCell.textContent);
    if (rowName) context.push(rowName);
  }

  const groupName = rowGroupNames.get(row);
  if (groupName) context.push(groupName);

  return context.join(', ');
}

function fixTarget() {
  const links = document.querySelectorAll('.wpdt-link-content');

  links.forEach((item) => {
    const elem = item;

    const target = elem.dataset.linkTarget;
    elem.setAttribute('target', target);

    // an empty aria-label would wipe the link's accessible name, so keep the native one
    const linkLabel = buildLinkLabel(elem);
    if (linkLabel) {
      elem.setAttribute('aria-label', linkLabel);
    }
  });
}

function a11yTable() {
  const tables = document.querySelectorAll('.wpDataTable');

  // prepare string suitable for id
  function prepareId(string) {
    return string.trim().toLowerCase().replaceAll(/&amp; |[,()]/gi, '').replaceAll(/(\s)+/gi, '_');
  }

  tables.forEach((table) => {
    const colsIds = [];
    const rowGroupsIds = [];
    let currentRowGroup = -1;
    let currentRowGroupName = '';

    table.querySelectorAll(':scope > thead th').forEach((col, key) => {
      const id = prepareId(col.innerText);

      col.setAttribute('id', id);
      colsIds[key] = id;
    });

    // table row iteration
    table.querySelectorAll('tbody tr').forEach((row) => {
      const firstTd = row.querySelector(':scope > td:first-child');

      // a row without its own cells (nested table wrapper, malformed markup) has nothing to label
      if (!firstTd) return;

      if (isGroupRow(row, colsIds.length)) {
        const id = prepareId(normalizeText(firstTd.textContent));

        firstTd.id = id;
        rowGroupsIds.push(id);
        currentRowGroup++;
        currentRowGroupName = normalizeText(row.textContent);
      } else {
        rowGroupNames.set(row, currentRowGroupName);

        row.querySelectorAll(':scope > td').forEach((cell, key) => {
          // no group row seen yet (ungrouped table) — currentRowGroup is -1, so skip the group id
          const groupId = rowGroupsIds[currentRowGroup];

          if (key === 0) {
            const id = prepareId(normalizeText(cell.textContent));
            cell.setAttribute('id', id);
          }

          const headers = (key === 0
            ? [colsIds[key], groupId]
            : [groupId, firstTd.id, colsIds[key]]
          ).filter(Boolean).join(' ');

          cell.setAttribute('headers', headers);
        });
      }
    });
  });
}

window.document.addEventListener('DOMContentLoaded', () => {
  // a11yTable() first — it resolves the row groups that fixTarget() puts into aria-label
  a11yTable();
  fixTarget();
});
